"use client";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useState } from "react";
import { useAuthDialogStore } from "@/hooks/use-auth-dialog";
import FormForgotPassword from "./form-forgot-password";

export const ForgotPasswordDialog = () => {
  const { forgotPassword, } = useAuthDialogStore();

  const [emailSent, setEmailSent] = useState(false);

  return (
    <Dialog open={forgotPassword.open} onOpenChange={forgotPassword.setOpen}>
      <DialogContent className="sm:max-w-[560px] !p-0 gap-0">
        <DialogHeader className="px-6 py-5 border-b">
          <DialogTitle>Нууц үг сэргээх</DialogTitle>
        </DialogHeader>
        <div className="px-4 py-5">
          <FormForgotPassword
            // emailSent={emailSent}
            // setEmailSent={setEmailSent}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
